import {actions as A} from '../constants/actions';

const saveTabFilters = type => payload => dispatch => dispatch({type, payload});

export const saveTab1Filters = saveTabFilters(A.SAVE_TAB_1_FILTERS);
export const saveTab2Filters = saveTabFilters(A.SAVE_TAB_2_FILTERS);
export const saveTab3Filters = saveTabFilters(A.SAVE_TAB_3_FILTERS);
export const saveTab4Values = saveTabFilters(A.SAVE_TAB_4_VALUES);
